import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import Modal from 'react-awesome-modal'
import AddToCartButton from 'Checkout/Cart/AddToCartButton'

class ModalVoltage extends Component {
  constructor () {
    super()
    this.state = {
      showConfirmVoltage: false
    }
  }
  confirmVoltage () {
    this.setState({ showConfirmVoltage: !this.state.showConfirmVoltage })
  }
  render () {
    return (
      <Fragment>
        <Button
          id={'voltagem'}
          text='Adicionar ao Carrinho'
          iconName='icon_cart'
          className='btn-icon btn btn-sm txt-uppercase txt-center btn-featured'
          onClick={() => this.confirmVoltage()}
        />
        <Modal
          width='375'
          height='auto'
          effect='fadeInUp'
          visible={this.state.showConfirmVoltage}
        >
          <div
            className={`modal-voltage col-12 bg-white py-3 mr-auto ml-auto`}
          >
            <div className='row px-3'>
              <div className='col'>
                <h3 className='txt-font-title'>Tem certeza que deseja o produto com a voltagem escolhida?</h3>
              </div>
            </div>
            <div className='col-12 pt-3'>
              <div className='row'>
                <div className='modal-back col-6 txt-right'>
                  <Button
                    id={'confirmar-voltagem'}
                    name={'confirmar-voltagem'}
                    className='btn btn-sm mx-0'
                    text='Voltar'
                    onClick={() => this.confirmVoltage()}
                  />
                </div>
                <div className='modal-back col-6 txt-right'>
                  <AddToCartButton sku={this.props.sku} vendorId={this.props.vendorId} goToCheckout className='btn-featured' noIcon />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    )
  }
}
ModalVoltage.propTypes = {
  sku: PropTypes.string,
  vendorId: PropTypes.string
}

export default ModalVoltage



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/ModalVoltage/index.js